import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';
import dsTokens from '@exploris/ce-design-system/tokens.json';

// Brand primary ramp (11 stops, 50–950) sourced from the design system — the
// single source of truth. A rebrand updates the package → this ramp → every
// PrimeNG component (buttons, dialogs, inputs, tables…). Values mirror
// ce-design-system color.primaryScale (and --primary-scale-* in colors.css).
const scale = dsTokens.color.primaryScale as unknown as Record<string, { $value: string }>;
const brandPrimary = Object.fromEntries(
  Object.entries(scale)
    .filter(([key]) => /^\d+$/.test(key))
    .map(([key, token]) => [key, token.$value])
) as Record<string, string>;

export const CardioExplorerPreset = definePreset(Lara, {
  semantic: {
    primary: brandPrimary,
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: '{primary.500}',
          focusBackground: '{primary.600}',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
        formField: {
          focusBorderColor: '{primary.500}',
          focusRing: {
            width: '1px',
            style: 'solid',
            color: '{primary.500}',
            offset: '0',
            shadow: '0 0 0 1px {primary.500}',
          },
        },
      },
    },
  },
  components: {
    datatable: {
      colorScheme: {
        light: {
          header: { background: '#ffffff' },
          headerCell: { background: '#ffffff', hoverBackground: '{surface.50}' },
        },
      },
    },
    paginator: {
      navButton: {
        width: '3rem',
        height: '3rem',
      },
    },
  },
});
